/* eslint-disable no-unused-vars */
import { ADD_VIEWED_LIST } from '@/store/modules/menu/actions.js'

export default {
  created() {
      
  },
  mounted() {
    this.addInListHistory()
  },
  methods: {
    addInListHistory() {
      const { menuNo } = this.$route.params
      this.$store.dispatch(ADD_VIEWED_LIST, { menuNo }).then(
        (data) => {
        }
      )
    }
  }
}
    